import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import add_img from "../../images/add_sec.svg";

/**
 * Add Section - Orange promotional card
 * Modernized with Shadcn Card component
 */
function Add_sec() {
    return (
        <Card className="bg-accent border-0 overflow-hidden h-full">
            <CardContent className="p-6 flex flex-col items-center justify-center text-center h-full min-h-[400px]">
                <h3 className="text-3xl md:text-3xl font-black text-white leading-tight mb-6">
                    Refer today & Earn Cash Every Time!
                </h3>
                <div className="mt-auto">
                    <img 
                        src={add_img} 
                        alt="Earn Cash" 
                        className="w-full max-w-[200px] mx-auto"
                    />
                </div>
            </CardContent>
        </Card>
    );
}

export default Add_sec;
